import { AccountantService, ClientService } from "../../../../services";
import {
	BackdropCircularProgress,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
} from "@websential/cosmic-v20";
import {
	EMPLOYEE_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	base64ToPdfFile,
	
	downloadBase64Txt,
	formatDate,
	savePdfAsFile,
	useNavigateToLogout,
	useRemoveQueriesOnUnmount
} from "../../../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { CollectionUploadedTransacitonsDataGrid } from "./CollectionUploadedTransacitonsDataGrid";
import { CollectionUploadedTransacitonsHeader } from "./CollectionUploadedTransacitonsHeader"
import { Description } from "@mui/icons-material";
import { IAppState } from "../../../../store/reducers";
import { IDropDownListResponse } from "../../../../models/common/IDropDownListResponse";
import { IGetListRequest } from "../../../../models";
import { TransactionsServices } from "../../../../services/DirectDeposit/TransactionsServices";
import { baseAppURL } from "../../../../common/http-commons";
import { boolean } from "yup";
import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { useNavigate } from "react-router-dom";

export interface ICollectionUploadedTransacitonsSetupPage { }
const COLLECTION_UPLOADED_TRANSACTIONS_QUERY_KEY = "collection-uploaded-transactions";

const useCollectionUploadedTransactions = (
	params: IGetListRequest,
	navigateToLogout: (path: any) => void
) =>
	useQuery({
		queryKey: [
			COLLECTION_UPLOADED_TRANSACTIONS_QUERY_KEY,
			params,
		],
		queryFn: () =>
			TransactionsServices.getCollectionUploadedTransacitonsList(
				params,
				navigateToLogout
			),
		refetchOnWindowFocus: false,
	});



export let collectionUploadedTransactionsFieldsTableInitialData = [
	{
		id: "1",
		file: null,
		description: null,

	},
];

export const CollectionUploadedTransactions: React.FC<ICollectionUploadedTransacitonsSetupPage> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [buttonTag, setButtonTag] = useState<any>(null);
	const [dialogButtonLabel, setDialogButtonLabel] = useState("");
	const [dialogContent, setDialogContent] = useState<any>(null);
	const [payPeriodPaymentDate, setPayPeriodPaymentDate] = useState<any>(null);

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRows, setSelectedRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [accountantId, setAccountantId] = useState("all");
	const [collectionUploadedTransacitonsData, setCollectionUploadedTransacitonsData] =
		useState<any>(undefined);

	// collectionUploaded Add Row Table
	const [collectionUploadedFieldsTableUpdatedData, setCollectionUploadedFieldsTableUpdatedData] =
		useState(collectionUploadedTransactionsFieldsTableInitialData);
	const [collectionUploadedFieldsDataItems, setCollectionUploadedFieldsDataItems] =
		useState(collectionUploadedTransactionsFieldsTableInitialData);


	const formMethods = useForm<any>({
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});


	const { isPending, data } = useCollectionUploadedTransactions(
		queryParams,
		navigateToLogout
	);
	const CollectionUploadedTransacitonsList: any | null = data;
	
	useEffect(() => {
		if (CollectionUploadedTransacitonsList) {
			setCollectionUploadedTransacitonsData(CollectionUploadedTransacitonsList);
		}
	}, [CollectionUploadedTransacitonsList]);


	const { isPending: isSubmitting, mutate: submitCollectionUploaded } = useMutation({
			mutationFn: TransactionsServices.createCollectionUploadedFiles,
			onSuccess: (res: IServerError | IResponse | any) => {
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong!",
					severity: res.status === false ? "error" : "success",
				});
				queryClient.invalidateQueries({ queryKey: [COLLECTION_UPLOADED_TRANSACTIONS_QUERY_KEY] })
				setCollectionUploadedFieldsDataItems(collectionUploadedTransactionsFieldsTableInitialData)
			},
			onError: (err: any) => {
				setSnackbarData({
					open: true,
					// message: "Something went wrong, try again later!",
					message: err.message,
					severity: "error",
				});
			},
		});

	const convertFileToBase64 = (file: File): Promise<string> => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result as string);
			reader.onerror = (error) => reject(error);
		});
	};

	const onSubmit = async (values: any) => {
		const atLeastOneFileSelected = collectionUploadedFieldsTableUpdatedData.some(
			(x: any) => x.file !== null
		);

		if (!atLeastOneFileSelected) {
			setSnackbarData({
				open: true,
				message: "Please select at least one file",
				severity: "error",
			});
			return;
		}

		const formatCollectionUploadedFieldsTableUpdatedData = (await Promise.all(
			collectionUploadedFieldsTableUpdatedData
				.filter((x: any) => {
					const hasFile = x.file !== null && x.file !== undefined;
					return hasFile;
				})
				.map(async (x: any) => {
					if (x.file && x.file.length > 0) {
						const file = x.file[0];
						const base64 = await convertFileToBase64(file);
						const cleanBase64 = base64.split(",")[1];
						return {
							...x,
							fileName:file.name,
							file: cleanBase64,
							description: x.description,
						};
					} else if (x.file) {
						const file = x.file;
						const base64 = await convertFileToBase64(file);
						const cleanBase64 = base64.split(",")[1];
						return {
							...x,
							fileName:file.name,
							file: cleanBase64,
							description: x.description,
						};
					}
					return null;
				})
		));

		const payload = {

			...values,
			formatCollectionUploadedFieldsTableUpdatedData,
		};
	

		submitCollectionUploaded(formatCollectionUploadedFieldsTableUpdatedData)
	};

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	useRemoveQueriesOnUnmount(["employee-report"]);

	const updatedCollectionUploadedTransactionsListItems = useMemo(() => {
		return (
			collectionUploadedTransacitonsData &&
			collectionUploadedTransacitonsData.items &&
			collectionUploadedTransacitonsData?.items.map((item: any) => ({
				...item,
			}))
		);
	}, [collectionUploadedTransacitonsData]);

	const expandedLabels = ["Transactions", "Collection"];
	const expandedCollectionUploadedOrSetupItem = "Collection Uploaded";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Collection" &&
				item.label === expandedCollectionUploadedOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedCollectionUploadedOrSetupItem && "/direct-deposit/transactions/collection-uploaded",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);

	const onParserClickedHandler = async (params: any) => {
		let path = `${baseAppURL}#/direct-deposit/transactions/collection-uploaded/parser/${params.id}`
		// navigate(path)
		window.open(path, "_blank")

	}
	const onDownloadClickedHandler = async (params: any) => {
		(async () => {
			try {
				setIsLoading(true)
				const response: any =
					await TransactionsServices.createDebitFileCollectionUploadedTransactions(params.id);
				if (response) {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",
							severity: "error",
						});
					} else if(response.status === 200){
						const filename = response.data.fileName;
						downloadBase64Txt(response.data.file, filename);
					}
				}
				// queryClient.invalidateQueries({ queryKey: [IN_PROCESS_COLLECTION_TRANSACTIONS_QUERY_KEY] })
			} catch { } finally { setIsLoading(false) }
		})();
	}
	const onViewClickedHandler = async (params: any) => {
		let path = `${baseAppURL}#/direct-deposit/transactions/collection-uploaded/view/${params.id}`
		// navigate(path)
		window.open(path, "_blank")
	}

	return (
		<>

			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"Collection Uploaded"}
			</div>

			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<CollectionUploadedTransacitonsHeader
						collectionUploadedTransactionsFieldsTableUpdatedData={(data: any) =>
							setCollectionUploadedFieldsTableUpdatedData(data)
						}
						collectionUploadedTransactionsFieldsDataItems={
							collectionUploadedFieldsDataItems
						}
					/>
				</form>
			</FormProvider>

			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={
						isPending ||
						isLoading ||
						isSubmitting

					}
					testId="collection-uploaded-transactions"
				/>


				<CollectionUploadedTransacitonsDataGrid
					columns={
						collectionUploadedTransacitonsData?.headerColumns
							? collectionUploadedTransacitonsData.headerColumns.filter(
								(item: any) => item.field !== "id"
							)
							: []
						// collectionUploadedTransacitonsData?.headerColumns ?? []
					}
					rows={
						collectionUploadedTransacitonsData && updatedCollectionUploadedTransactionsListItems
							? updatedCollectionUploadedTransactionsListItems
							: []
						// collectionUploadedTransacitonsData?.items ?? []
						// itams
					}
					showIndexColumn={true}
					showChecboxColumn={false}
					showSettingColumn={false}
					// onImportButtonClickedHandler={onImportFileClicked}
					// onImportExcelButtonClickedHandler={onExcelToPdfClicked}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						collectionUploadedTransacitonsData && collectionUploadedTransacitonsData.total
							? collectionUploadedTransacitonsData.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					searchFieldPlaceholder={"Search..."}
					pageTitle={"collection uploaded"}
					selectedRows={(value: any) => setSelectedRows(value)}
					onDownloadClickedHandler={onDownloadClickedHandler}
					onParserClickedHandler={onParserClickedHandler}
					onViewClickedHandler={onViewClickedHandler}

				/>

			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
